<app-dea-widget-wrapper>
  <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height: 96px;">
    <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
  </div>
  <div *ngIf="!loading && error" class="d-flex justify-content-center align-items-center" style="height: 96px;">
    {{error.message}}
  </div>
  <div *ngIf="!loading && !error" class="m-0 p-0">
    <div class="border rounded p-3">
      <app-user-device-box [device]="device"></app-user-device-box>
    </div>
    <div class="v-spacer"></div>
    <div class="v-spacer"></div>
    <div *ngFor="let tech of device?.history; let first = first;" class="row m-0 p-0 mb-3">
      <div class="border rounded">
        <div class="row m-0 p-0 pt-3 cursor-pointer" routerLink="/utente/{{tech.owner?.id ?? 'ID-ERROR'}}">
          <div class="col-auto m-0 p-0">
            <app-dea-thumbnail-img size="64" [id]="tech.owner?.id"></app-dea-thumbnail-img>
          </div>
          <div class="col m-0 p-0 ps-3">
            <app-user-base-data [showFullData]="false" [showArrow]="true" [user]="tech.owner"></app-user-base-data>
          </div>
        </div>
        <!-- ASSIGNMENT -->
        <div *ngIf="tech.__type?.toLowerCase() === 'assignment'" class="m-0 p-0 py-3">
          <app-user-tech-block-section-head [label]="'Assegnazione'" [tech]="tech" [editBtn]="false" />
        </div>
        <!-- ASSIGNMENT -->
        <!-- INSURANCE -->
        <div *ngIf="isInsurance(tech)" class="m-0 p-0 py-3">
          <app-user-tech-block-section-head [label]="'Assicurazione'" [tech]="tech" [editBtn]="false" />
          <div class="row m-0 p-0 mt-3">
            <div class="col m-0 p-0 fs-075r opacity-75 d-flex flex-column gap-3">
              <div *ngIf=" tech.expiration !==undefined">
                Scadenza: <span class="fw-semibold">{{tech.expiration | toItDateDdMmmmYyyy}}</span>
              </div>
              <div *ngIf="tech.value !== undefined">
                Totale: <span class="fw-semibold">{{ tech.value | currency:'EUR':'':'1.2-2' }} €</span>
              </div>
            </div>
            <div class="col m-0 p-0 fs-075r opacity-75">
              Allegato: <span class="fw-semibold">{{tech.hasDocument() ? 'Sì' : 'No'}}</span>
              <span *ngIf="tech.document !== undefined && tech.document.id !== undefined"
                (click)="downloadDoc(tech.document.id)" class="ms-4 text-decoration-underline pointer">
                Scarica
              </span>
            </div>
          </div>
        </div>
        <!-- INSURANCE -->
        <!-- LOSS -->
        <div *ngIf="isLoss(tech)" class="m-0 p-0 py-3">
          <app-user-tech-block-section-head [label]="'Furto / Smarrimento'" [tech]="tech" [editBtn]="false" />
          <div class="row m-0 p-0 mt-3">
            <div *ngIf="tech.note !== undefined && tech.note !== ''" class="col m-0 p-0 fs-075r opacity-75">
              Note: <span class="fw-semibold">{{tech.note}}</span>
            </div>
            <div class="col m-0 p-0 fs-075r opacity-75">
              Allegato: <span class="fw-semibold">{{tech.hasDocument() ? 'Sì' : 'No'}}</span>
              <span *ngIf="tech.document !== undefined && tech.document.id !== undefined"
                class="ms-4 text-decoration-underline pointer" (click)="downloadDoc(tech.document.id)">Scarica</span>
            </div>
          </div>
        </div>
        <!-- LOSS -->
        <!-- BREAKING -->
        <div *ngIf="isBreaking(tech)" class="m-0 p-0 py-3">
          <app-user-tech-block-section-head [label]="'Guasto / Rottura'" [tech]="tech" [editBtn]="false" />
          <div class="row m-0 p-0 mt-3 gap-3">
            <div *ngIf="tech.type !== undefined" class="col m-0 mb-1 p-0 fs-075r opacity-75">
              Tipo: <span class="fw-semibold">{{tech.type}}</span>
            </div>
            <div *ngIf="tech.note !== undefined" class="col m-0 mb-1 p-0 fs-075r opacity-75">
              Note: <span class="fw-semibold">{{tech.note}}</span>
            </div>
          </div>
        </div>
        <!-- BREAKING -->
        <!-- RETURN -->
        <div *ngIf="isReturn(tech)" class="m-0 p-0 py-3">
          <app-user-tech-block-section-head [label]="'Restituzione'" [tech]="tech" [editBtn]="false" />
          <div class="row m-0 p-0 mt-3 gap-3">
            <div *ngIf="tech.status !== undefined" class="col m-0 mb-1 p-0 fs-075r opacity-75">
              Stato: <span class="fw-semibold">{{tech.status}}</span>
            </div>
            <div *ngIf="tech.items !== undefined && tech.items.length > 0" class="col m-0 mb-1 p-0 fs-075r opacity-75">
              Oggetti: <span class="fw-semibold">{{tech.items.join(", ")}}</span>
            </div>
          </div>
          <div *ngIf="tech.note !== undefined && tech.note !== ''" class="col m-0 p-0 fs-075r opacity-75 mt-3">
            Note: <span class="fw-semibold">{{tech.note}}</span>
          </div>
        </div>
        <!-- RETURN -->
        <!-- RELEASE -->
        <div *ngIf="isRelease(tech)" class="m-0 p-0 py-3">
          <app-user-tech-block-section-head [label]="'Riscatto'" [tech]="tech" [editBtn]="false" />
          <div class="row m-0 p-0 mt-3">
            <div class="col m-0 p-0 fs-075r opacity-75 d-flex flex-column gap-3">
              <div *ngIf="tech.payment_date !== undefined">
                Data pagamento: <span class="fw-semibold">{{ tech.payment_date | toItDateDdMmmmYyyy }}</span>
              </div>
            </div>
            <div class="col m-0 p-0 fs-075r opacity-75 d-flex flex-column gap-3">
              <div *ngIf="tech.value !== undefined">
                Importo: <span class="fw-semibold">{{ tech?.value | currency:'EUR':'':'1.2-2' }} €</span>
              </div>
            </div>
          </div>
          <div *ngIf="tech.hasDocument() || (tech.note !== undefined && tech.note !== '')" class="row m-0 p-0 mt-3">
            <div *ngIf="tech.hasDocument()" class="col m-0 p-0 fs-075r opacity-75">
              Allegato: <span class="fw-semibold">{{tech.hasDocument() ? 'Sì' : 'No'}}</span>
              <span *ngIf="tech.document !== undefined && tech.document.id !== undefined"
                class="ms-4 text-decoration-underline pointer" (click)="downloadDoc(tech.document.id)">Scarica</span>
            </div>
            <div *ngIf="tech.note !== undefined && tech.note !== ''" class="col m-0 p-0 fs-075r opacity-75 mt-3">
              Note: <span class="fw-semibold">{{tech.note}}</span>
            </div>
          </div>
        </div>
        <!-- RELEASE -->
      </div>
    </div>
  </div>
</app-dea-widget-wrapper>